import styled, { css } from 'styled-components';
import { hocus, focusOutline, breakpoints } from 'themes/helpers';
import { ButtonProps } from './Button';
import isPropValid from '@emotion/is-prop-valid';

const loading = css`
  &,
  &:hover,
  &:focus {
    cursor: default;
    color: rgba(255, 255, 255, 0);
  }
`;

export const StyledButton = styled.button.withConfig({
  shouldForwardProp: (prop) => isPropValid(prop),
})<ButtonProps>`
  padding: 8px
    ${({ theme, isFull }) => (isFull ? theme.space(6) : theme.space(14))}px;
  margin-top: ${({ theme }) => theme.space(2)}px;
  font-weight: 600;
  font-size: ${({ fontSize, theme }) => fontSize || theme.fontSize[1]}px;
  border: solid 1px ${({ theme }) => theme.palette.primary.primary600};
  border-radius: 32px;
  outline: none;
  text-align: center;
  position: relative;
  cursor: pointer;

  @media (min-width: ${() => breakpoints.tablet}px) {
    font-size: ${({ fontSize, theme }) => fontSize || theme.fontSize[2]}px;
    padding: 12px
      ${({ theme, isFull }) => (isFull ? theme.space(8) : theme.space(15))}px;
  }

  ${focusOutline({})};

  color: ${({ theme }) => theme.palette.primary.primary600};
  ${({ isFull }) => (isFull ? 'width: 100%;' : 'width: fit-content;')}
  ${({ disabled }) =>
    disabled
      ? `
      cursor: not-allowed;
      opacity: 0.3;`
      : ''}
  ${({ variant = 'primary', theme }) => {
    switch (variant) {
      case 'primary':
        return `
           color: ${theme.palette.neutral.surface};
           background-color: ${theme.palette.primary.primary600};
           ${hocus()}{
            background-color: ${theme.palette.primary.primary700};
           }
           path { fill:${theme.palette.neutral.surface};}
           svg { fill: ${theme.palette.neutral.surface};}

        `;
      case 'outline':
        return `
        background-color: transparent;
        ${hocus()}{
          background-color: ${theme.palette.primary.primary50};
        }
        `;

      case 'transparent':
        return `
        border: none;
        background: transparent;
        ${hocus()}{
          background-color: ${theme.palette.primary.primary50};
        }
        `;
    }
  }}
    ${({ isLoading }) => (isLoading ? loading : '')}
`;
